import React from 'react'

export default function PlanCard({title, plan, amount, style, handlePlanChange}) {
  return (
    <>
       <div onClick={() => handlePlanChange(plan, amount, title)} role="button" tabindex="0"
                  className={`flex items-center w-full rounded-lg p-4 cursor-pointer focus:outline-none border ${style ? "border-blue-600 bg-blue-50 text-blue-500": 'border-gray-200 text-gray-500'}`}>
                  <div className="flex items-center w-full">
                    <svg className="fill-current inline-block overflow-visible h-6 w-6 mr-3 text-current"
                      name="bolt" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24"
                      height="24" fill="currentColor" >
                      <path fill-rule="evenodd"
                        d="M11.93 4.092c-.03.01-.07.03-.109.087l-6.01 8.683c-.1.144.002.342.178.342h5.025a.77.77 0 0 1 .77.769v5.723c0 .07.02.108.039.134a.23.23 0 0 0 .113.074c.05.016.098.014.135.003.03-.01.07-.03.109-.087l6.01-8.683a.218.218 0 0 0-.178-.342h-5.025a.77.77 0 0 1-.77-.769V4.303a.21.21 0 0 0-.039-.134.23.23 0 0 0-.113-.074.231.231 0 0 0-.135-.003zm-1.373-.79c.98-1.413 3.2-.722 3.2 1.001v4.954h4.255c1.416 0 2.25 1.59 1.444 2.755l-6.012 8.684c-.98 1.413-3.2.723-3.2-1v-4.954H5.99c-1.416 0-2.25-1.59-1.443-2.756l6.01-8.683z"
                        clip-rule="evenodd"></path>
                    </svg>
                    <div className="flex flex-col gap-2">
                      <div className="text-sm text-gray-800 font-semibold w-full flex-grow">{title}
                      </div>
                      <div className="text-sm text-gray-800 text-left flex-shrink flex-grow-0 w-full">
                        <span><span className="font-semibold">{amount}</span> / {plan}</span></div>
                    </div>
                  </div>
                </div>
    </>
  )
}
